// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";
import { roles } from "../../../utils/constants";
import _ from "lodash";

const searcher = localStorage.getItem("billingSearcher");
const searcherObj = JSON.parse(searcher);

const initialState = {
  bills: [],
  institutionsFilter: {
    unique: [],
    multiple: [],
    all: [],
  },
  languagesFilter: {
    unique: [],
    multiple: [],
    all: [],
  },
  countType: {
    unique: 0,
    multiple: 0,
    external: 0,
    all: 0,
  },
  loading: false,
  pagination: searcherObj?.pagination
    ? searcherObj.pagination
    : {
        totalDocuments: 0,
        totalPages: 0,
        currentPage: 1,
        pageSize: 10,
        sorter: undefined,
      },
};

export const getBilling = createAsyncThunk(
  "posts/getBilling",
  async ({ search = "", key }, thunkAPI) => {
    const res = await http.get(`/bills?${search}`);

    const billsCopy = JSON.parse(JSON.stringify(res.data.bills));

    const sortedByBilling = billsCopy.sort((a, b) => {
      const valA = a?.prestationsRef?.billing?.description;
      const valB = b?.prestationsRef?.billing?.description;

      // undefined/null en dernier
      if (!valA && !valB) return 0;
      if (!valA) return 1;
      if (!valB) return -1;

      return valA.localeCompare(valB);
    });

    let payload = {
      ...res.data,
      bills: sortedByBilling,
    };

    return { ...payload, key };
  },
);

export const getUniqueInstitutionsBills = createAsyncThunk(
  "bills/getUniqueInstitutionsBills",
  async (billId, thunkAPI) => {
    const res = await http.get("/bills/institutions");
    return res.data;
  },
);

export const getCountType = createAsyncThunk(
  "bills/types",
  async (year, thunkAPI) => {
    const res = await http.get("/bills/types?year=" + year);
    return res.data;
  },
);

export const getUniqueLanguagesInBills = createAsyncThunk(
  "bills/getUniqueLanguagesInBills",
  async (billId, thunkAPI) => {
    const res = await http.get("/bills/languages");
    return res.data;
  },
);

const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setPagination: (state, { payload }) => {
      state.pagination = _.cloneDeep({ ...state.pagination, ...payload });
    },
    clearBilling: state => {
      return initialState;
    },
    clearBills: state => {
      state.bills = [];
    },
  },
  extraReducers: {
    [getBilling.pending]: state => {
      state.loading = true;
    },
    [getBilling.fulfilled]: (state, { payload }) => {
      state.loading = false;

      const { totalDocuments, totalPages, currentPage, pageSize } = payload;

      state.countType.external = payload.external;
      state.countType.multiple = payload.multiple;
      state.countType.unique = payload.unique;
      state.countType.all = payload.all;

      state.pagination.totalDocuments = totalDocuments;
      state.pagination.totalPages = totalPages;
      state.bills = payload.bills;
      // state.pagination.currentPage = currentPage;
      // state.pagination.pageSize = pageSize;
      // state.bills = payload.bills.sort((a, b) => {
      //   return a.bill_number - b.bill_number;
      // });
    },
    [getUniqueInstitutionsBills.pending]: state => {
      state.loading = true;
    },
    [getUniqueInstitutionsBills.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.institutionsFilter = payload;
    },
    [getCountType.fulfilled]: (state, { payload }) => {
      state.countType = payload;
    },
    [getUniqueLanguagesInBills.pending]: state => {
      state.loading = true;
    },
    [getUniqueLanguagesInBills.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.languagesFilter = payload;
    },
    [getBilling.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export const { clearBilling, clearBills, setPagination } = billingSlice.actions;

export const billingReducer = billingSlice.reducer;
